<template>
  <div id="main">
    <div id="current" style="margin-left: 20px; margin-right: 20px">
      <el-form ref="currentPage" :model="currentPage">
        <el-row>
          <el-form-item>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
              <el-breadcrumb-item>许可配置</el-breadcrumb-item>
            </el-breadcrumb>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="最大许可数" :label-width="formLabelWidth">
              <el-input-number v-model="licCfgData.LIC_MAX_COUNT"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="最小许可数" :label-width="formLabelWidth">
              <el-input-number v-model="licCfgData.LIC_MIN_COUNT" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="最大有效天数" :label-width="formLabelWidth">
              <el-input-number v-model="licCfgData.LIC_MAX_DAYS" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="最小有效天数" :label-width="formLabelWidth">
              <el-input-number v-model="licCfgData.LIC_MIN_DAYS" ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="许可类型" :label-width="formLabelWidth">
            <el-button-group>
              <el-button type="text" icon="el-icon-plus" @click="onClickAddPage">添加</el-button>
              <el-button type="text" icon="el-icon-minus" @click="onClickDelPage">删除</el-button>
              <el-button type="text" icon="el-icon-edit" @click="onClickEditPage">编辑</el-button>
            </el-button-group>
            <el-tree
                :highlight-current=true
                :default-expand-all=false
                :expand-on-click-node="false"
                :data="pages"
                :props="defaultProps"
                :draggable="true"
                :allow-drop="allowDrop"
                node-key="pageid"
                accordion
                @node-click="onSelectPage"
                @node-drop="sort"
                class="licmode-tree"
                ref="pageTree"
                :filter-node-method="filterPageNode"
            >
              <template #default="scope">
                <span class="custom-tree-node">
                    {{ scope.data.label }}
                </span>
              </template>
            </el-tree>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item style="text-align: right">
              <el-button type="primary" icon="el-icon-check" @click="onClickOk()">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage, ElMessageBox} from "element-plus";
import TableView from "@/components/tableView";
import ChartView from "@/components/ChartView";
import eventInsim from "@/event";
import queryConfig from "@/components/queryConfig.vue";
// import FenceView from "@/components/FenceView";
//兼容语法 async focus

export default {
  components: {ChartView, TableView,queryConfig},
  // components: {ChartView, TableView, FenceView},
  data() {
    return {
      formLabelWidth: '100px',
      pageType: {
        "table": {
          label: "报表",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_day": {
          label: "报表(年月日)",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_mon": {
          label: "报表(年月)",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_year": {
          label: "报表(年度)",
          route: "components/busView.vue",
          needTemplate: true
        },
        "chart": {
          label: "曲线",
          route: "components/busView.vue",
          needTemplate: true
        },
        "chart_wellGroup": {
          label: "曲线(井组)",
          route: "components/busView.vue",
          needTemplate: true
        },
        "fence": {
          label: "栅状图",
          route: "components/busView.vue",
          needTemplate: true
        },
        "docUpload": {
          label: "文档上传",
          route: "views/resultsManagementViews/upload/docUploadView.vue",
          needTemplate: false
        },
        "tjUpload": {
          label: "图件上传",
          route: "views/resultsManagementViews/upload/tjUploadView.vue",
          needTemplate: false
        },
        "gqUpload": {
          label: "工区上传",
          route: "views/resultsManagementViews/upload/gqUploadView.vue",
          needTemplate: false
        },
        "workUpload": {
          label: "工作总结上传",
          route: "views/resultsManagementViews/upload/workUploadView.vue",
          needTemplate: false
        },
        "module-setting": {
          label: "模块管理",
          route: "views/systemSettingViews/moduleManagerView.vue",
          needTemplate: false
        },
        "page-setting": {
          label: "页面管理",
          route: "views/systemSettingViews/pageManagerView.vue",
          needTemplate: false
        },
        "datasrc-setting": {
          label: "数据源管理",
          route: "views/systemSettingViews/datasrcManagerView.vue",
          needTemplate: false
        },
        "results-verify": {
          label: "成果审核",
          route: "views/resultsManagementViews/resultsVerifyView.vue",
          needTemplate: false
        },
        "work-verify": {
          label: "工作总结审核",
          route: "views/resultsManagementViews/workVerifyView.vue",
          needTemplate: false
        },
        "results-ios": {
          label: "数据成等值图",
          route: "views/resultsManagementViews/isoView.vue",
          needTemplate: false
        },
        "feedVerifyFlow": {
          label: "反馈流程设置",
          route: "views/systemSettingViews/feedVerifyFlowMgr.vue",
          needTemplate: false
        },
        "resultVerifyFlowMgr": {
          label: "成果审核流程设置",
          route: "views/systemSettingViews/resultVerifyFlowMgr.vue",
          needTemplate: false
        },
        "assessVerifyFlowMgr": {
          label: "考核审核流程设置",
          route: "views/systemSettingViews/assessVerifyFlowMgr.vue",
          needTemplate: false
        },
        "assessZBVerifyFlowMgr": {
          label: "上报考核指标审核流程设置",
          route: "views/systemSettingViews/assessZBVerifyFlowMgr.vue",
          needTemplate: false
        },
        "homePageView": {
          label: "首页",
          route: "views/dataCompAppViews/homePageView.vue",
          needTemplate: false
        },
        "warningSetting":{
          label:"预警设置",
          route:"components/warningSetting.vue",
          needTemplate: false
        },
        "dataScreenList":{
          label:"数据甄别记录",
          route:"components/dataScreenList.vue",
          needTemplate: true
        },
        "decreasingContrast": {
          label: "递减数据表",
          route: "components/decreasingContrast.vue",
          needTemplate: true
        },
        "table_assess": {
          label: "考核指标发布",
          route: "components/busView.vue",
          needTemplate: true
        },
        "IndexAlgorithm": {
          label: "指标算法管理",
          route: "views/assessmentViews/IndexAlgorithmMangerView.vue",
          needTemplate: false
        },
        "AlgorithmResult": {
          label: "考核算法数据查看",
          route: "views/assessmentViews/AlgorithmResultMangerView.vue",
          needTemplate: false
        },
        "table_upload_dynamic": {
          label: "动态监测资料质量上传",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_upload_produce": {
          label: "安全生产上传",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_upload_tackle": {
          label: "攻关申请上传",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_upload_scheme": {
          label: "综合治理方案上传",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_assess_obj": {
          label: "评分异议记录",
          route: "components/busView.vue",
          needTemplate: true
        },
        "table_enter_csj": {
          label: "措施井报表录入",
          route: "components/busView.vue",
          needTemplate: true
        }
      },
      pageName: "",
      isAdmin:false,
      remark:"",
      sortcache:{},
      theHeader:[], //所有的列
      choseHeader:[],//已选择的列
      form:{
        name:"",//表格名称
        isFixed:false,//是否开启冻结
        isFixedNum:0,//冻结行数
        data:[],//数据
        dataNum:0,
        pagination:true,//分页器
        dataSource:"",//所选数据源
        operation:false,//操作列
      },
      isCreateUser:false,//是否是创建用户
      licCfgData: {
        LIC_MIN_DAYS:1,
        LIC_MAX_DAYS:90,
        LIC_MIN_COUNT:1,
        LIC_MAX_COUNT:2,
      },
      currentPage: {
        pageid: "",
        seq: 0,
        label: "",
        remark:"",
        pid: "root",
        lev: 1,
        isLeaf: false,
        type: "",
        route: "",
        template: [],
        isScreening:false,//数据甄别标识
        isFeedback:false,//数据问题反馈标识
      },
      pages: [],
      refreshDialogVisible:false,//查询页面是否开启
      queryFilter:[],//查询条件
      queryConfigNum:{
        num1:1,
        num2:1
      },//条件查询的唯一表示
    }
  },
  mounted: function () {
    //获取配置参数
    let that = this;
    axios({
      url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/licCfg",
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        console.log("配置查询数据：",res.data)
        if(res.data.length >0) {
          that.licCfgData = res.data[0]
        }
      }
      that.loading = false;
    }).catch((err) => {
      alert('Error');
      console.log(err)
      that.loading = false;
    })
    //获取许可类型
    this.refreshPageTree({},0)
  },
  methods: {
    async fetchAllPage() {
      let that = this;
      await axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/licMode",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          console.log("页面配置查询数据：",res.data)
          that.pages = res.data
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    async refreshPageTree(parentPage, selIndex) {
      let that = this
      await that.fetchAllPage();
      // if (Object.keys(parentPage).length === 0) {
      //   if (selIndex < 0) {
      //     that.currentPage = that.pages[that.pages.length + selIndex]
      //   }
      //   else {
      //     that.currentPage = that.pages[selIndex]
      //   }
      // }
      // else {
      //   parentPage = that.findPage(that.pages, parentPage)
      //   if (selIndex < 0) {
      //     that.currentPage = parentPage.children[parentPage.children.length + selIndex]
      //   }
      //   else {
      //     that.currentPage = parentPage.children[selIndex]
      //   }
      // }
      // that.currentPage.template = []
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        //aboveId:父节点id
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },
    sort(draggingNode, dropNode, type) {
      let that = this;
      let data = type != "inner" ? dropNode.parent.data : dropNode.data;
      let nodeData = dropNode.level == 1 && type != "inner" ? data : data.children;
      nodeData =Array.from(nodeData);
      nodeData.forEach(element =>{
        element.pid = data.id;
      });
      nodeData.forEach((element, i) => {
        // 向上拖动
        if(draggingNode.data.seq>dropNode.data.seq) {
          if(element.seq<=draggingNode.data.seq&&element.seq>=dropNode.data.seq) {
            let Seq = element.seq;
            Seq = Seq.toString();
            let M = element.lev;
            let temSeq="";
            if(i+1<10){
              temSeq = Seq.substring(0,2*M-1) + "0"+ ""+(i+1) + Seq.substring(2*M+1);
              element.seq = temSeq;
            }
            else {
              temSeq = Seq.substring(0,2*M-1) + ""+(i+1) + Seq.substring(2*M+1);
              element.seq = temSeq;
            }
            // 处理子节点
            if(element.isLeaf==false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j=0;j<len;j++) {
                leafSeq = element.children[j].seq
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if(i+1<10){
                  temleafSeq = leafSeq.substring(0,2*M-1) + "0"+ ""+(i+1) + leafSeq.substring(2*M+1);
                  element.children[j].seq = temleafSeq;
                }
                else {
                  temleafSeq = leafSeq.substring(0,2*M-1) + ""+(i+1) + leafSeq.substring(2*M+1);
                  element.children[j].seq = temleafSeq;
                }
                that.sortcache[element.children[j].pageid]=temleafSeq;
              }
            }

            that.sortcache[element.pageid]=temSeq;
          }
        }
        // 向下拖动
        else {
          if(element.seq>=draggingNode.data.seq&&element.seq<=dropNode.data.seq) {
            let Seq = element.seq;
            Seq = Seq.toString();
            let M = element.lev;
            let temSeq="";
            if(i+1<10){
              temSeq = Seq.substring(0,2*M-1) + "0"+ ""+(i+1) + Seq.substring(2*M+1);
              element.seq = temSeq;
            }
            else {
              temSeq = Seq.substring(0,2*M-1) + ""+(i+1) + Seq.substring(2*M+1);
              element.seq = temSeq;
            }
            // 处理子节点
            if(element.isLeaf==false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j=0;j<len;j++) {
                leafSeq = element.children[j].seq
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if(i+1<10){
                  temleafSeq = leafSeq.substring(0,2*M-1) + "0"+ ""+(i+1) + leafSeq.substring(2*M+1);
                  element.children[j].seq = temleafSeq;
                }
                else {
                  temleafSeq = leafSeq.substring(0,2*M-1) + ""+(i+1) + leafSeq.substring(2*M+1);
                  element.children[j].seq = temleafSeq;
                }
                that.sortcache[element.children[j].pageid]=temleafSeq;
              }
            }

            that.sortcache[element.pageid]=temSeq;
            console.log(that.sortcache)
          }
        }
      });

    },
    onSearchPageNode() {
      this.$refs.pageTree.filter(this.pageName)
    },
    onClearPageName() {
      this.pageName = ""
      this.$refs.pageTree.filter(this.pageName)
    },
    filterPageNode(value, data) {
      if (!value) {
        return true
      }
      return data.label.indexOf(value) !== -1
    },
    findPage(node, page) {
      let item = null
      for (let i = 0; i < node.length; i++) {
        console.log(node[i].pageid + " " + page.pageid)
        if (node[i].pageid == page.pageid) {
          item = node[i]
          break
        }
        if (!node[i].isLeaf) {
          const it = this.findPage(node[i].children, page)
          if (it) {
            return it
          }
        }
      }
      return item
    },
    addPage(parentPage) {
      let that = this;
      ElMessageBox.prompt(
          '许可类型',
          '输入',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
      ).then(({ value }) => {
        let name = (value != null) ? `${value}` : ""
        if (name.trim() == "") {
          ElMessage({
            type: 'warning',
            message: '名称不能为空',
          })
          return
        }
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/saveLicMode",
          method: 'PUT',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            label: name,
          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.refreshPageTree(parentPage,-1)
            ElMessage({
              type: 'success',
              message: '许可添加成功',
            })
          }
          that.loading = false;
        }).catch((err) => {
          alert('Error');
          console.log(err)
          that.loading = false;
        })
      })
    },
    onSelectPage(node) {
      this.currentPage = {}
      this.currentPage.id = node.id;
      this.currentPage.label = node.label;
      this.isCreateUser = false;
      console.log(this.currentPage,node);
    },
    onClickAddPage() {
      this.isCreateUser = true;
      this.addPage({})
    },
    onClickAddChildPage() {
      this.addPage(this.currentPage)
    },
    onClickEditPage(){
      let that = this;
      ElMessageBox.prompt(
          '许可类型',
          '输入',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValue: that.currentPage.label,
          },
          'dddd'
      ).then(({ value }) => {
        let name = (value != null) ? `${value}` : ""
        if (name.trim() == "") {
          ElMessage({
            type: 'warning',
            message: '名称不能为空',
          })
          return
        }
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/editLicMode",
          method: 'PUT',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            label: name,
            id: that.currentPage.id
          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.refreshPageTree({},0)
            ElMessage({
              type: 'success',
              message: '许可编辑成功',
            })
          }
          that.loading = false;
        }).catch((err) => {
          alert('Error');
          console.log(err)
          that.loading = false;
        })
      })
    },
    onClickDelPage() {
      let that = this
      ElMessageBox.confirm(
          '确定删除？',
          '警告',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
          }
      ).then(() => {
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/delLicMode",
          method: 'DELETE',
          headers: {
            "Content-Type": "application/json"
          },
          data: that.currentPage
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.refreshPageTree({},0)
            ElMessage({
              type: 'success',
              message: '删除成功',
            })
          }
          that.loading = false;
        }).catch((err) => {
          alert('Error');
          console.log(err)
          that.loading = false;
        })
      })
    },
    onChangePageType(type) {
      let that = this;
      that.currentPage.type = type;
      that.currentPage.route = that.pageType[type].route;
      that.currentPage.template = [];
    },
    //点击配置模板
    openTemplateConfig() {
      let that = this;
      if (that.currentPage.type.indexOf("table")!=-1 || that.currentPage.type == "dataScreenList"|| that.currentPage.type == "decreasingContrast") {
        that.$refs.tableView.initConfig(that.currentPage.pageid);
        that.$refs.tableView.config();
      }
      else if (that.currentPage.type.indexOf("chart") != -1) {
        that.$refs.chartView.queryTemplateConfig(that.currentPage.pageid);
        that.$refs.chartView.isShow = true;
      }
      else if (that.currentPage.type == "fence") {
        alert('fenceView');
      }
    },
    doResetUserPwd(){
      console.log("11111")
      this.currentPage.user_pwd = "a123B123c";
    },
    async onClickOk() {
      let that  = this
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/licCfg",
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        data: that.licCfgData
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          ElMessage({
            type: 'success',
            message: '更新成功',
          })
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    //监听查询
    numChange(data){
      this.queryConfigNum.num1=data.num1;
      this.queryConfigNum.num2=data.num2;
      console.log(this.queryConfigNum)
    },
    //点击 筛选按钮
    async refresh() {
      this.refreshDialogVisible = true;
      this.theHeader = [];
      this.queryFilter = [];
      //获取筛选条件,改异步传输为同步
      await this.getCommonGridFilter();
      let num1 = 0;
      let num2 = 0;
      let arr1 = [];
      let arr2 = [];
      for (let i in this.queryFilter) {
        arr2.push(this.queryFilter[i].code)
        for (let j in this.queryFilter[i].children) {
          arr1.push(this.queryFilter[i].children[j].code)
    }
      }
      if(arr1.length>0 ){
        arr1 = arr1.sort()
        num1 = arr1[arr1.length - 1];
      }
      if(arr2.length>0 ){
        arr2 = arr2.sort()
        num2 = arr2[arr2.length - 1];
      }
      console.log(num1, num2);
      // this.theHeader = this.$refs.tableView.theHeader;
      console.log("表头字段：",this.theHeader);
      this.$nextTick(() => {
        this.$refs.queryConfig.queryFilter = this.queryFilter;
        this.$refs.queryConfig.num1 = num1;
        this.$refs.queryConfig.num2 = num2;
      }, 100)
    },
    //查询 筛选信息
    async getCommonGridFilter() {
      await axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getcommonpagefilter",
        method: 'POST',
        data:{
            pageId: this.currentPage.pageid
        }
      }).then((res) => {
        console.log("获取过滤条件", res)
        if (res.data.result=="success"){
          this.queryFilter=res.data.queryFilter;
          this.theHeader = res.data.headerData;
        }
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //查询条件置空
    refreshReset(){
      this.$refs.queryConfig.queryFilter=[{
        code:0,//组别唯一序列号
        logic:"",//与其他组别的关系
        show:false,//折叠状态
        children:[{
          logic:"",//逻辑
          field:"",//字段
          symbol:"",//条件
          value:"",//值
          code:0//条件唯一序列号
        }],
      }];
      this.$refs.queryConfig.num1=1;
      this.$refs.queryConfig.num2=1;
      this.queryFilter = [];
      //保存筛选条件
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commonpagefilter", {
        pageId: this.currentPage.pageid,
        queryFilter: this.queryFilter
      }).then(res => {
        console.log("保存过滤条件", res)
        ElMessage("过滤条件保存成功")
      });
    },
    //查询页面点击提交
    refreshOk(){
      let queryFilter = this.$refs.queryConfig.queryFilter;
      queryFilter[0].logic="";
      for(let i in queryFilter){
        for(let j in queryFilter[i].children){
          for(let k in queryFilter[i].children[j]){
            //console.log(k+"="+queryFilter[i].children[j][k])
            if(queryFilter[i].children[j][k]===""){
              if(j==0&&k=="logic"){
                continue
              }else{
                ElMessage("您有未填写查询条件,请补全后再提交")
                return
              }
            }
          }
        }
      }
      console.log(queryFilter);
      console.log(this.currentPage);
      //保存筛选条件
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commonpagefilter", {
        pageId: this.currentPage.pageid,
        queryFilter: queryFilter
      }).then(res => {
        console.log("保存过滤条件", res)
        ElMessage("过滤条件保存成功")
      });
      this.queryFilter = queryFilter;
      // this.queryGridData(true);
      this.refreshDialogVisible = false;
    },
  }
}
</script>
<style lang="less">
.el-row {
  margin-bottom: 20px;
}
.licmode-tree {
  position: relative;
  overflow: auto;
  width: 600px;
  height: 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.remark {
  width: 550px;
}
</style>